import { useEffect } from 'react';
import Lottie from 'lottie-web';
import styled, { css } from 'styled-components';

const LoaderElement = styled.div<{ opacity: number; zIndex?: number; transparent: boolean }>`
  display: flex;
  width: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  transform: translate3d(0, 0, 0);
  margin: auto;
  opacity: ${({ opacity }) => opacity};
  background-color: ${({ transparent }) => (transparent ? 'transparent' : 'white')};
  ${({ zIndex }) =>
    zIndex
      ? css`
          z-index: ${zIndex};
        `
      : null}
`;

type LoaderProps = {
  id?: string;
  opacity?: number;
  zIndex?: number;
  transparent?: boolean;
};

export default function Loader({ id = 'loader', opacity = 1, zIndex, transparent = false }: LoaderProps) {
  useEffect(() => {
    const element = document.getElementById(id);
    if (element) {
      const anim = Lottie.loadAnimation({
        container: element,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        path: 'data.json',
      });
      return () => {
        anim.destroy();
      };
    }
    return () => {};
  }, [id]);

  return <LoaderElement id={id} opacity={opacity} zIndex={zIndex} transparent={transparent} />;
}
